/* eslint-disable complexity */
/* eslint-disable no-implicit-globals */

function colorchangestatus() {
  $('.' + ACC.orderHistory.phPanelTitle).each(function() {
    var status = $(this).find('.ph-orderhistory__status').html();

    if (status !== null) {
      status = status.trim().replace(/ /g, '_').toUpperCase();
    }

    switch (status) {
        case 'CREATED':
        case 'AUTHORIZATION_SENT':
        case 'AUTHORIZATION_SUCCESS':
        case 'PAYMENT_CAPTURED':
        case 'PAYMENT_NOT_CAPTURED':
        case 'PAYMENT_CAPTURE_SENT':
        case 'PAYMENT_CAPTURE_SUCCESS':
        case 'REFUND_SUCCESS':
        case 'REFUND_SENT':
        case 'FRAUD_CHECKED':
        case 'CHECKED_VALID':
        case 'CHECKED_INVALID':
        case 'PAYMENT_AUTHORIZED':
        case 'SUSPENDED':
        case 'PARTIAL_RETURN_SUBMITTED':
        case 'REFUND_SYNC_FAILURE':
        case 'REFUND_ASYNC_FAILURE':
        case 'PAYMENT_CAPTURE_SYNC_FAILURE':
        case 'PAYMENT_CAPTURE_ASYNC_FAILURE':
        case 'WAIT_FRAUD_MANUAL_CHECK':
        case 'ORDER_SPLIT':
        case 'PAYMENT_NOT_AUTHORIZED':
        case 'AUTHORIZATION_SYNC_FAILURE':
        case 'AUTHORIZATION_ASYNC_FAILURE':
        case 'PAYMENT_AMOUNT_NOT_RESERVED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__blue');

          break;

        case 'ERROR':
        case 'CANCELLED':
        case 'PROCESSING_ERROR':
        case 'PHILIPS_SYSTEM_ERROR':
        case 'B2B_PROCESSING_ERROR':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__red');

          break;

        case 'COMPLETED':
        case 'DELIVERED':
        case 'PAYMENT_AMOUNT_RESERVED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__green');

          break;

        case 'CANCELLING':
        case 'PARTIALLY_INVOICED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__yellow');

          break;

        case 'RETURN_ORDER':
        case 'RETURNED':
        case 'PARTIALLY_RETURNED':
        case 'RETURN_CANCELLED':
        case 'RETURN_IN_PROGRESS':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__purple');

          break;

        case 'ASSIGNED_TO_ADMIN':
        case 'ASSIGN_ADMIN':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__pink');

          break;

        case 'SHIPPED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__aqua');

          break;

        case 'REJECTED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__walitared');

          break;

        case 'PENDING_APPROVAL':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__aqualight');

          break;

        case 'INVOICED':
          $(this).find('.ph-orderhistory-dot').addClass('ph-orderhistory__philipsblue');

          break;

        default:
          $(this).find('.ph-orderhistory-dot').css('color', '#000000 !important');
    }
  });
}

$(document).ready(function() {
  if ($('.' + ACC.orderHistory.phPanelTitle).length > 0) {
    $(document).on('click', '.' + ACC.orderHistory.phPanelTitle, function() {
      var accordionParent = $(this).parents('.ph-orderhistory_panel'),
          divAccordion = $(this).find('.' + ACC.orderHistory.phAccToggle),
          isExpand = divAccordion.attr(ACC.orderHistory.ariaExpanded),
          orderId = accordionParent.find('.' + ACC.orderHistory.orderHistoryTitle).text();

      accordionParent.find('.' + ACC.orderHistory.phPanelCollapse).toggleClass(ACC.orderHistory.phIn);
      accordionParent.siblings().find('.' + ACC.orderHistory.phPanelCollapse).removeClass(ACC.orderHistory.phIn);

      if (isExpand === 'true') {
        accordionParent.find('.' + ACC.orderHistory.phAccToggle).attr(ACC.orderHistory.ariaExpanded, 'false');
        $(this).addClass('ph-icon-arrow-down').removeClass(ACC.orderHistory.iconArrowUp);
      } else {
        accordionParent.find('.' + ACC.orderHistory.phAccToggle).attr(ACC.orderHistory.ariaExpanded, 'true');
        $(this).removeClass('ph-icon-arrow-down').addClass(ACC.orderHistory.iconArrowUp);
        ACC.omniture.bindTrackConversion('interaction', 'expands:order_number_' + orderId);
      }
    });
    $(document).on('click', '.ph-orders__invoice__details_link', function() {
      var $invoiceHolder = $(this).closest('.ph-orders__invoice__details'),
          popClass = 'ph-orders__invoice__details_popup',
          $invoicePopup = $invoiceHolder.find('.' + popClass),
          isVisible = $invoicePopup.hasClass(ACC.orderHistory.hidden),
          $invoicePopupBox = $('.' + popClass);

      $invoicePopupBox.addClass(ACC.orderHistory.hidden);

      if (isVisible) {
        $invoicePopup.removeClass(ACC.orderHistory.hidden);
      }
    }).on('click', function(event) {
      if ($(event.target).closest('.ph-orders__invoice__details').length === 0) {
        $('.ph-orders__invoice__details_popup').addClass(ACC.orderHistory.hidden);
      }
    });
  }

  $('.' + ACC.orderHistory.orderHistoryTitle).each(function() {
    if ($(this).text() === location.hash) {
      $(this).parents('.ph-orderhistory__container').find('.' + ACC.orderHistory.phPanelCollapse).addClass(ACC.orderHistory.phIn);
      $(this).parents('.ph-orderhistory__container').find('.' + ACC.orderHistory.phPanelTitle).addClass(ACC.orderHistory.iconArrowUp);
      window.scrollTo({
        top: $(this).offset().top,
        behavior: 'smooth'
      });
    }
  });

  colorchangestatus();

  function showLoading(checkData) {
    var receivedOrder = checkData;

    if (receivedOrder === ACC.orderHistory.phOrders) {
      var pageLengthOrder = $('.' + ACC.orderHistory.phMyOrders).find('.' + ACC.orderHistory.panelHeading).length / $('.ph-ordersshown').html(),
          numberOfPagesOrder = parseInt($('.orderNav .ph-ordersshown').attr('data-pagenumber'), 10),
          pageLengthsOrder = Math.ceil(pageLengthOrder);

      if ((pageLengthsOrder < parseInt($('.ph-getOrderHistoryUrl').attr('data-number-of-pages'), 10)) && (pageLengthsOrder <= numberOfPagesOrder)) {
        $('.' + ACC.orderHistory.phLoad).show();
      }

      if (pageLengthsOrder >= numberOfPagesOrder) {
        $('.' + ACC.orderHistory.phLoad).hide();
      }
    } else {
      var pageLength = $('.' + ACC.orderHistory.phApprovalOrders).find('.' + ACC.orderHistory.panelHeading).length / $('.ph-ordersshown').html(),
          numberOfPages = parseInt($('.orderApprovalNav .ph-ordersshown').attr('data-pagenumber'), 10),
          pageLengths = Math.ceil(pageLength);

      if ((pageLengths < parseInt($('.ph-getOrderApprovalHistoryUrl').attr('data-number-of-pages'), 10)) && (pageLengths <= numberOfPages)) {
        $('.' + ACC.orderHistory.phLoad).show();
      }

      if (pageLengths >= numberOfPages) {
        $('.' + ACC.orderHistory.phLoad).hide();
      }
    }
  }

  function showApprovalOrders() {
    $('.ph-activeApprovalCheck').attr(ACC.orderHistory.dataActive, 'true');
    $('.' + ACC.orderHistory.activeOrderCheck).attr(ACC.orderHistory.dataActive, 'false');
    showLoading(ACC.orderHistory.phMyApprovalOrders);
    $('.orderApprovalNav').show();
    $('.orderNav').hide();
    $('.' + ACC.orderHistory.phApprovalOrders).show();
    $('.' + ACC.orderHistory.phMyOrders).hide();
    $('.' + ACC.orderHistory.phOrders).attr('disabled', true);
  }

  function showOrders() {
    showLoading(ACC.orderHistory.phOrders);
    $('.' + ACC.orderHistory.phMyOrders).show();
    $('.' + ACC.orderHistory.phApprovalOrders).hide();
    $('.ph-myApprovalOrders').attr('disabled', true);
    $('.orderApprovalNav').hide();
    $('.ph-allOrders').hide();
    $('.ph-sporderplacedby').addClass(ACC.orderHistory.hidden);
  }

  if ($('.' + ACC.orderHistory.phOrders).is(':checked')) {
    showOrders();
  } else if ($('.ph-myApprovalOrders').is(':checked')) {
    showLoading(ACC.orderHistory.phMyApprovalOrders);
  }

  $('.' + ACC.orderHistory.phOrders).on('change', function() {
    if ($(this).is(':checked')) {
      $('.' + ACC.orderHistory.activeOrderCheck).attr(ACC.orderHistory.dataActive, 'true');
      showOrders();
    } else {
      $('.' + ACC.orderHistory.activeOrderCheck).attr(ACC.orderHistory.dataActive, 'false');
      $('.' + ACC.orderHistory.phMyOrders).hide();
      $('.ph-myApprovalOrders').attr('disabled', false);
      $('.ph-allOrders').show();
      $('.ph-sporderplacedby').removeClass(ACC.orderHistory.hidden);
    }

    if (!$(this).is(':checked') && !$('.ph-myApprovalOrders').is(':checked')) {
      $('.' + ACC.orderHistory.phMyOrders).show();
    }
  });

  $('.ph-myApprovalOrders').on('change', function() {
    if ($(this).is(':checked')) {
      showApprovalOrders();
    } else {
      $('.ph-activeApprovalCheck').attr(ACC.orderHistory.dataActive, 'false');
      $('.orderApprovalNav').hide();
      $('.orderNav').show();
      $('.' + ACC.orderHistory.phApprovalOrders).hide();
      $('.' + ACC.orderHistory.phOrders).attr('disabled', false);
    }

    if (!$(this).is(':checked') && !$('.' + ACC.orderHistory.phOrders).is(':checked')) {
      $('.' + ACC.orderHistory.phMyOrders).show();
    }
  });

  $(window).on('scroll', function() {
    if ($('.' + ACC.freetextordersearch.textSearchData).find('.' + ACC.orderHistory.panelHeading).length === 0) {
      if ($('.ph-myApprovalOrders').is(':checked')) {
        showLoading(ACC.orderHistory.phMyApprovalOrders);
      } else {
        showLoading(ACC.orderHistory.phOrders);
      }
    }
  });

  $(document).on('click', '.ph-download-invoice', function() {
    ACC.omniture.bindTrackConversion('download', 'link:invoice_number_' + $(this).text());
  });

  $(document).on('click', '.ph-download-rmd', function() {
    ACC.omniture.bindTrackConversion('download', 'link:rmd_number_' + $(this).text());
  });

  $(document).on('click', '.ph-orderhistory__offlinesearch', function() {
    ACC.omniture.bindTrackConversion('interaction', 'link:search_order');
  });

  $(document).on('click', '.ph-searchorder', function() {
    ACC.omniture.bindTrackConversion('interaction', 'button:search_order');
  });
});

ACC.orderHistory = {
  panelHeading: 'ph-orderhistory_panelheading',
  phMyOrders: 'ph-myOrders-data',
  phApprovalOrders: 'ph-myApprovalOrders-data',
  phPanelTitle: 'ph-orderhistory_paneltitle',
  phAccToggle: 'accordion-toggle',
  ariaExpanded: 'aria-expanded',
  phPanelCollapse: 'ph-orderhistory_panelcollapse',
  dataActive: 'data-active',
  phLoad: 'ph-load',
  phIn: 'ph-in',
  phOrders: 'ph-myOrders',
  phMyApprovalOrders: 'ph-myApprovalOrders',
  iconArrowUp: 'ph-icon-arrow-up',
  hidden: 'hidden',
  activeOrderCheck: 'ph-activeOderCheck',
  invoicePopup: 'ph-orders__invoice__details_popup',
  orderHistoryTitle: 'ph-orderhistory_title',
  orderHistoryToBeShippedHeadingClass: '.ph-orderHistory__toBeShipped--heading',
  orderHistoryQtyTextClass: '.ph-orderhistory_qtytext',
  toBeShippedProductDetailClass: '.ph-toBeShippedProductDetail--',
  bindAll: function() {
    this.prepareLazyload();
  },
  prepareLazyload: function() {
    $(document).on('click', '.' + ACC.orderHistory.phPanelTitle, function() {
      var accordionParent = $(this).parents('.ph-orderhistory_panel'),
          historyTitle = $(this).find('.' + ACC.orderHistory.orderHistoryTitle),
          orderIdCode = historyTitle.attr('data-orderid').trim(),
          isSparePart = historyTitle.attr('data-isSparePartOrder');

      accordionParent.find('.' + ACC.orderHistory.phPanelCollapse).attr('id', 'orderPanel' + orderIdCode);

      if ($('.ph-ishhs').html() === 'true') {
        if ($(this).hasClass('triggeredProductDataJson') === false) {
          ACC.orderHistory.loadOrderHistoryProductDetailsData(orderIdCode, accordionParent);
          $(this).addClass('triggeredProductDataJson');
        }
      } else {
        var isLazyLoadedClassPresent = $(this).hasClass('lazyloaded');

        if (isLazyLoadedClassPresent === false) {
          ACC.orderHistory.orderHistoryDynamicallyLoaded(orderIdCode, accordionParent, isSparePart);
          $(this).addClass('lazyloaded');
        }
      }
    });
  },

  orderHistoryDynamicallyLoaded: function(orderIdCode, accordionParent, isSparePart) {
    $.ajax({
      url: ACC.config.contextPath + '/lazyload/getEstDeliveryNTrackingURL?code=' + orderIdCode,
      dataType: 'json',
      async: true,
      success: function(response) {
        if (isSparePart === 'true') {
          ACC.orderHistory.processSpLazyLoad(response, accordionParent, orderIdCode);
        } else {
          ACC.orderHistory.processLazyLoad(response, accordionParent, orderIdCode);
        }
      }
    });
  },

  loadOrderHistoryProductDetailsData: function(orderIdCode, accordionParent) {
    $.ajax({
      url: ACC.config.contextPath + '/my-account/getOrderEntryDetails?orderCode=' + orderIdCode,
      dataType: 'html',
      async: true,
      success: function(response) {
        if (response) {
          var productDetailsMain = accordionParent.find('.ph-orderhistory_products'),
              productDetailsPanelBodyMain = accordionParent.find('.ph-orderhistory__panelbody');

          productDetailsMain.remove();
          productDetailsPanelBodyMain.append(response);

          var linkedInvoiceMain = productDetailsPanelBodyMain.find('.ph-orderHistory_linkedInvoice_Wrapper');

          productDetailsPanelBodyMain.find('.ph-lazyloaded-invoices').html(linkedInvoiceMain.html());
          linkedInvoiceMain.hide();
        }
      }
    });
  },

  processSpLazyLoad: function(results, accordionParent, orderIdCode) {
    if (String(results[orderIdCode].invoiceDetails) !== 'null') {
      var $translationItem = $('.invoiceRmdDetails'),
          itemOpening = '<td class="ph-orders__invoice__details_item" data-title="',
          dataObj = {
            orderIdCode: orderIdCode,
            itemOpening: itemOpening
          };

      $.each(results[orderIdCode].invoiceDetails, function(key, val) {
        if (val.spOrderEntryDetailsDataList.length > 0) {
          var invoiceListHtml = '',
              deliveryItemNumber = Number(val.deliveryItemNumber);

          $.each(val.spOrderEntryDetailsDataList, function(k, v) {
            if (ACC.orderHistory.checkTrack(v)) {
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.setTooltipTableHeader(v, k, $translationItem);
              invoiceListHtml = invoiceListHtml + '<tr>\n';
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.generateSpInvoiceHtml(v, val, dataObj, $translationItem);
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.generateSpSelfInvoiceHtml(v, val, dataObj, $translationItem);
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.generateSpRmdNumberHtml(v, val, dataObj, $translationItem);
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.generateSpRmdStatusHtml(v, val, dataObj, $translationItem);
              invoiceListHtml = invoiceListHtml + ACC.orderHistory.generateSpTrackingeHtml(v, itemOpening);
              invoiceListHtml = invoiceListHtml + '</tr>\n';
            }
          });
          invoiceListHtml = invoiceListHtml + '</tbody>\n</table>\n</div>';
          accordionParent.find('#productDetails_' + deliveryItemNumber).html(invoiceListHtml);
        }
      });
    }
  },
  checkTrack: function(data) {
    var isRequired = false;

    $.each(data, function(k, v) {
      if (String(v) !== 'null') {
        isRequired = true;
      }
    });

    return isRequired;
  },
  setTooltipTableHeader: function(data, key, $translationItem) {
    var tableHead = '',
        completelyProcessed = 'Completely processed',
        rmdStatus = 'data-rmdstatus';

    if (key === 0) {
      tableHead = tableHead + '<a href="javascript:void(0)" class="ph-orders__invoice__details_link ph-position-relative">' + $translationItem.attr('data-invoiceText') + '</a>';

      tableHead = tableHead + '<div class="ph-orders__invoice__details_popup ph-position-absolute ph-p-2 ph-mt-1 hidden">';
      tableHead = tableHead + '<table class="ph-orders__invoice__details_table">\n<thead>\n<tr class="ph-invoice__table__header">';

      if (String(data.invoiceNumber) !== 'null') {
        tableHead = tableHead + '<th>' + $translationItem.attr('data-invoicenumber') + '</th>';
      }

      if (String(data.selfInvoiceNumber) !== 'null') {
        tableHead = tableHead + '<th>' + $translationItem.attr('data-selfinvoicenumber') + '</th>';
      }

      if (String(data.rmdNumber) !== 'null' && String(data.rmdStatus) !== completelyProcessed) {
        tableHead = tableHead + '<th>' + $translationItem.attr('data-rmdnumber') + '</th>';
      } else if (String(data.rmdNumber) !== 'null' && String(data.rmdStatus) === completelyProcessed) {
        tableHead = tableHead + '<th></th>';
      }

      if (String(data.rmdStatus) !== 'null') {
        tableHead = tableHead + '<th>' + $translationItem.attr(rmdStatus) + '</th>';
      }

      if (String(data.trackNumber) !== 'null') {
        tableHead = tableHead + '<th>' + $translationItem.attr('data-trackNumber') + '</th>';
      }

      tableHead = tableHead + '</tr>\n</thead>\n<tbody>\n';
    }

    return tableHead;
  },
  generateSpInvoiceHtml: function(data, list, dataObj, $translationItem) {
    var invoiceNumber = $translationItem.attr('data-invoicenumber'),
        invoiceUrl = $translationItem.attr('data-invoiceUrl'),
        invoiceListHtml = '';

    if (data.invoiceNumber && String(data.invoiceNumber) !== 'null') {
      var invoicePdfUrl = '/my-account/orders/invoicePDF?invoiceNumber=' + data.invoiceNumber + '&orderNumber=' + dataObj.orderIdCode;

      invoiceListHtml = invoiceListHtml + dataObj.itemOpening + invoiceNumber + '">';

      if (list.useInvoicePDF) {
        invoiceListHtml = invoiceListHtml + '<a target="_blank" href="' + invoicePdfUrl + '" class="ph-download-button ph-download-invoice">' + data.invoiceNumber + '</a>';
      } else {
        invoiceListHtml = invoiceListHtml + '<a href="javascript:void(0)" data-orderNumber="' + dataObj.orderIdCode + '" data-entryNumber="' + list.deliveryItemNumber + '"';
        invoiceListHtml = invoiceListHtml + ' data-invoiceUrl="' + invoiceUrl + '" data-invoiceNumber="' + data.invoiceNumber;
        invoiceListHtml = invoiceListHtml + '" class="ph__invoiceno__click ph-download-invoice">';
        invoiceListHtml = invoiceListHtml + data.invoiceNumber + '</a>';
      }

      invoiceListHtml = invoiceListHtml + '</td>';
    }

    return invoiceListHtml;
  },
  generateSpSelfInvoiceHtml: function(data, list, dataObj, $translationItem) {
    var selfInvoice = $translationItem.attr('data-selfinvoicenumber'),
        selfinvoiceUrl = $translationItem.attr('data-selfinvoiceUrl'),
        invoiceListHtml = '';

    if (data.selfInvoiceNumber && String(data.selfInvoiceNumber) !== 'null') {
      invoiceListHtml = invoiceListHtml + dataObj.itemOpening + selfInvoice + '">';
      invoiceListHtml = invoiceListHtml + '<a href="javascript:void(0)"  data-entryNumber="' + list.deliveryItemNumber + '" data-rmdNumber="' + data.rmdNumber + '"';
      invoiceListHtml = invoiceListHtml + ' data-selfinvoiceUrl="' + selfinvoiceUrl + '" data-selfInvoiceNumber="' + data.selfInvoiceNumber + '" class="ph__selfinvoiceno__click">';
      invoiceListHtml = invoiceListHtml + data.selfInvoiceNumber + '</a></td>';
    }

    return invoiceListHtml;
  },
  generateSpRmdNumberHtml: function(data, list, dataObj, $translationItem) {
    var rmdNumber = $translationItem.attr('data-rmdnumber'),
        rmddownloadUrl = $translationItem.attr('data-rmddownloadUrl'),
        invoiceListHtml = '';

    if (data.rmdNumber && String(data.rmdNumber) !== 'null') {
      var rmdPdfUrl = '/my-account/orders/rmdDownlaodPdf?rmdNumber=' + data.rmdNumber + '&orderNumber=' + dataObj.orderIdCode;

      invoiceListHtml = invoiceListHtml + dataObj.itemOpening + rmdNumber + '">';

      if (data.rmdStatus === 'Completely processed') {
        invoiceListHtml = invoiceListHtml + ' ';
      } else if (list.useRmdPDF) {
        invoiceListHtml = invoiceListHtml + '<a target="_blank" href="' + rmdPdfUrl + '" class="ph-download-button ph-download-rmd">' + data.rmdNumber + '</a>';
      } else {
        invoiceListHtml = invoiceListHtml + '<a href="javascript:void(0)" data-rmdNumber="' + data.rmdNumber + '" data-rmddownloadUrl="' + rmddownloadUrl + '"';
        invoiceListHtml = invoiceListHtml + ' class="ph__rmdnumber__click ph-download-rmd">' + data.rmdNumber + '</a>';
      }

      invoiceListHtml = invoiceListHtml + '</td>';
    }

    return invoiceListHtml;
  },
  generateSpRmdStatusHtml: function(data, list, dataObj, $translationItem) {
    var rmdTitle = $translationItem.attr('data-rmdstatus'),
        rmdStatus = '',
        invoiceListHtml = '';

    if (data.rmdStatus && String(data.rmdStatus) !== 'null') {
      rmdStatus = $translationItem.attr('data-' + data.rmdStatus.replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
      invoiceListHtml = invoiceListHtml + dataObj.itemOpening + rmdTitle + '">' + rmdStatus + '</td>';
    }

    return invoiceListHtml;
  },
  generateSpTrackingeHtml: function(data, itemOpening) {
    var trackNumber = $('.invoiceRmdDetails').attr('data-tracknumber'),
        invoiceListHtml = '';

    if (data.trackNumber && String(data.trackNumber) !== 'null') {
      invoiceListHtml = invoiceListHtml + itemOpening + trackNumber + '">';

      if (String(data.trackUrl) !== 'null') {
        invoiceListHtml = invoiceListHtml + '<a href="' + data.trackUrl + '" target="_blank">';
      }

      invoiceListHtml = invoiceListHtml + data.trackNumber;

      if (String(data.trackUrl) !== 'null') {
        invoiceListHtml = invoiceListHtml + '</a>';
      }

      invoiceListHtml = invoiceListHtml + '</td>';
    }

    return invoiceListHtml;
  },

  estimatedDateOrShippedDateSubDetails: function(singleOrder, accordionParent, invoiceDetail) {
    if (singleOrder.deliveryItemList) {
      for (var deliveryIndex = 0; deliveryIndex < singleOrder.deliveryItemList.length; deliveryIndex = deliveryIndex + 1) {
        var deliveryItm = singleOrder.deliveryItemList[deliveryIndex],
            productMain = accordionParent.find('#lazyloadestdate' + invoiceDetail.confirmationNumber + '_' + invoiceDetail.deliveryItemNumber),
            invoiceDetailDeliveryNumber = invoiceDetail.deliveryNumber;

        if ((deliveryItm.shipmentStatus === 'S' || deliveryItm.shipmentStatus === 'I') && deliveryItm.shipmentDate && invoiceDetailDeliveryNumber === deliveryItm.deliveryNumber) {
          var shipmentDateDetails = ACC.orderHistory.shippedOnDetails(deliveryItm.shipmentDate);

          accordionParent.find('.ph-loadestdate').hide();
          productMain.html(shipmentDateDetails);
          productMain.parent('.ph-orderhistory_prodinfo').find('.ph-orderHistory__backOrdered').addClass('ph-d-none');
        }
      }
    }
  },

  estimatedDateOrShippedDate: function(results, accordionParent, orderIdCode) {
    var singleOrder = results[orderIdCode];

    if (singleOrder.invoiceDetails) {
      for (var invoiceIndex = 0; invoiceIndex < singleOrder.invoiceDetails.length; invoiceIndex = invoiceIndex + 1) {
        var invoiceDetail = singleOrder.invoiceDetails[invoiceIndex];

        if ((invoiceDetail.shipmentStatus !== 'S' && invoiceDetail.shipmentStatus !== 'I') && invoiceDetail.estDelDate) {
          var estimatedDeliveryDateDetails = ACC.orderHistory.estDeliveryDetails(invoiceDetail.estDelDate);

          accordionParent.find('.ph-loadestdate').hide();
          accordionParent.find('#lazyloadestdate' + invoiceDetail.confirmationNumber + '_' + invoiceDetail.deliveryItemNumber).html(estimatedDeliveryDateDetails);
        }

        ACC.orderHistory.estimatedDateOrShippedDateSubDetails(singleOrder, accordionParent, invoiceDetail);
      }
    }
  },

  processLazyLoad: function(results, accordionParent, orderIdCode) {
    if (String(results[orderIdCode].invoiceDetails) !== 'null') {
      var invoiceDetails = results[orderIdCode].invoiceDetails,
          invoiceButtonFlag = false,
          linkedinvoicetitle = $('.linkedinvoicetitle').text().trim(),
          invoiceListHtml = '<div class="ph-orderhistory__linkedinvoice ph-orderhistory_border ph-orderhistory_fontstyle ph-py-2 ph-col-12 ph-px-0 ph-float-left">',
          productEntryCounterMain = 0;

      invoiceListHtml = invoiceListHtml + '<span class="strong ph-col-12 ph-float-left ph-mb-1">' + linkedinvoicetitle + '</span>';

      if (String(results[orderIdCode].invoiceButtonFlag) && String(results[orderIdCode].invoiceButtonFlag) === 'true') {
        accordionParent.find('.ph-lazyloaded-invoices').removeClass(ACC.orderHistory.hidden);
        invoiceButtonFlag = results[orderIdCode].invoiceButtonFlag;
      }

      var invoiceInfo = ACC.orderHistory.generateInvoiceListHtml(invoiceDetails, invoiceButtonFlag);

      invoiceListHtml = invoiceListHtml + invoiceInfo;

      invoiceListHtml = invoiceListHtml + '</div>';

      if (invoiceInfo !== '') {
        accordionParent.find('.ph-lazyloaded-invoices').html(invoiceListHtml);
      }

      accordionParent.find('.ph-lazyload-deliveryitemlist').each(function() {
        if (String(results[orderIdCode].deliveryItemList) !== 'null') {
          var deliveryItemList = results[orderIdCode].deliveryItemList,
              $currentProduct = $(this),
              invoiceDetailsDeliveryItemArray = [];

          for (var inv = 0; inv < invoiceDetails.length; inv = inv + 1) {
            var invoiceDetail = invoiceDetails[inv];

            if (invoiceDetailsDeliveryItemArray.indexOf(invoiceDetail.deliveryNumber) < 0) {
              invoiceDetailsDeliveryItemArray.push(invoiceDetail.deliveryNumber);

              productEntryCounterMain = ACC.orderHistory.generatePackingListHtml($currentProduct, invoiceDetail, deliveryItemList, productEntryCounterMain);
            }
          }
        }
      });

      ACC.orderHistory.estimatedDateOrShippedDate(results, accordionParent, orderIdCode);

      var packagenumPrev = '';

      accordionParent.find('.ph-lazyload-deliveryitemlist').each(function() {
        var $currentProduct = $(this);

        var packagenum = $currentProduct.find('.ph-packagelist-foritem').attr('packagenum');

        if (packagenumPrev === packagenum && packagenumPrev !== '') {
          $currentProduct.hide();
        }

        packagenumPrev = packagenum;
      });
      ACC.orderHistory.generateTrackingHtml(accordionParent, invoiceDetails);
    }
  },
  generateTrackingNumberWithUrl: function(trackingNumber, trackingURL, shipmenttrackmsg) {
    var trackingWithUrl = '',
        shipToUrl = '',
        seperator = ', ',
        finalUrl = '',
        trackingUrlArr = '';

    if (trackingNumber) {
      trackingUrlArr = trackingURL.split(',');

      for (var k = 0; k < trackingUrlArr.length; k = k + 1) {
        if (k === trackingUrlArr.length - 1) {
          seperator = '';
        }

        shipToUrl = trackingUrlArr[k].replace('RDC:', '');
        finalUrl = shipToUrl.split('|');
        trackingWithUrl = trackingWithUrl + '<a href="' + finalUrl[1] + '" target="_blank" class="confirmation-link">' + finalUrl[0] + '</a>' + seperator;
      }

      trackingWithUrl = ' (Track: ' + trackingWithUrl + '):';
    } else {
      trackingWithUrl = ' (<a href="' + trackingURL + '" target="_blank" class="confirmation-link">' + shipmenttrackmsg + '</a>) &nbsp;';
    }

    return trackingWithUrl;
  },
  generateTrackingHtml: function(accordionParent, invoiceDetails) {
    var shippedlabelmsg = $('.shippedlabelmsg').text().trim(),
        shipmenttrackmsg = $('.shipmenttrackmsg').text().trim(),
        trackingNumberWithUrl = '',
        isHiddableItem = '',
        prevTrackUrl = '',
        prevTrackNum = '',
        prevDeliveryNumber = '';

    for (var t = 0; t < invoiceDetails.length; t = t + 1) {
      var trackingHtml = '',
          invoiceDetail = invoiceDetails[t];

      isHiddableItem = 'nothidden';

      if (String(invoiceDetail.trackingURL) !== 'null') {
        if (prevTrackUrl === invoiceDetail.trackingURL && invoiceDetail.deliveryNumber === prevDeliveryNumber) {
          isHiddableItem = ACC.orderHistory.hidden;
        }

        prevTrackUrl = invoiceDetail.trackingURL;
        trackingNumberWithUrl = ACC.orderHistory.generateTrackingNumberWithUrl(invoiceDetail.trackingNumber, invoiceDetail.trackingURL, shipmenttrackmsg);
        trackingHtml = shippedlabelmsg + trackingNumberWithUrl;
      } else if (String(invoiceDetail.trackingNumber) !== 'null') {
        if (prevTrackNum === invoiceDetail.trackingNumber && invoiceDetail.deliveryNumber === prevDeliveryNumber) {
          isHiddableItem = ACC.orderHistory.hidden;
        }

        prevTrackNum = invoiceDetail.trackingNumber;

        var shipmentlabelmsg = $('.shipmentlabelmsg').text().trim(),
            shipmentcarriername = accordionParent.find('.shipmentcarriername').text();

        if (shipmentcarriername !== '') {
          trackingHtml = shipmentlabelmsg + ': ' + shipmentcarriername + ' - ' + invoiceDetail.trackingNumber + '&nbsp;';
        }
      }

      prevDeliveryNumber = invoiceDetail.deliveryNumber;

      ACC.orderHistory.finalTrackingHtml(trackingHtml, accordionParent, invoiceDetail, isHiddableItem);
    }
  },

  finalTrackingHtml: function(trackingHtml, accordionParent, invoiceDetail, isHiddableItem) {
    var lazyLoadTrackingMain = accordionParent.find('#lazyloadTracking' + invoiceDetail.confirmationNumber + '_' + invoiceDetail.deliveryItemNumber);

    if (trackingHtml !== '') {
      lazyLoadTrackingMain.html(trackingHtml).addClass(isHiddableItem);

      ACC.orderHistory.hideShippedLabelIfAlreadyPresent(lazyLoadTrackingMain, isHiddableItem);
    }
  },

  hideShippedLabelIfAlreadyPresent: function(lazyLoadTrackingMain, isHiddableItem) {
    var $shippedLabelClassMain = lazyLoadTrackingMain.siblings('.ph-orderHistory__shippedLabelClass'),
        isShippedLabelClassPresent = $shippedLabelClassMain.length;

    if (isHiddableItem === 'nothidden' && isShippedLabelClassPresent > 0) {
      $shippedLabelClassMain.addClass('ph-d-none');
    }
  },

  estimationDate: function(accordionParent, invoiceDetail) {
    if (String(invoiceDetail.estDelDate) !== 'null' && String(invoiceDetail.estDelDate) !== '') {
      var estdeliverydate = invoiceDetail.estDelDate;
      var estItemHtml = '<div class="ph-col-12 ph-float-left ph-mt-1 ph-p-0 ph-orderhistory_productname"><span>' + $('.estdeliverylabel').text() + '</span>: <span>' + estdeliverydate + '</span></div>';

      accordionParent.find('.ph-loadestdate').hide();
      accordionParent.find('#lazyloadestdate' + invoiceDetail.confirmationNumber + '_' + invoiceDetail.deliveryItemNumber).html(estItemHtml);
    }
  },

  generateCurrencySymbol: function(productEntryData, currency, qtyBasedPrice) {
    var qtyBasedPriceWithSymbol = '';

    if (productEntryData && productEntryData.basePrice && productEntryData.basePrice.currencyIso) {
      var currencyIso = productEntryData.basePrice.currencyIso;

      switch (currencyIso.toUpperCase()) {
          case 'USD':
            qtyBasedPriceWithSymbol = currency + qtyBasedPrice;

            break;

          case 'EUR':
            qtyBasedPriceWithSymbol = qtyBasedPrice + currency;

            break;

          default:
            qtyBasedPriceWithSymbol = currency + qtyBasedPrice;
      }
    }

    return qtyBasedPriceWithSymbol;
  },

  shippedProductPriceCalculation: function(currentProduct, qtyDelivered, deliveryItm) {
    var savedOrderDetailsMapData = $('.ph-orderHistory__savedProductEntryData').data('key'),
        productsMainClass = '.ph-orderhistory_products',
        currentProductMainClass = currentProduct.parents(productsMainClass),
        orderCode = currentProductMainClass.attr('data-orderidnumber'),
        currentOrderDetails = savedOrderDetailsMapData[orderCode],
        currentOrderProductEntries = currentOrderDetails.entries,
        deliveryItmMaterialNumber = String(deliveryItm.materialNumber),
        qtyShippedPrice = '';

    for (var currentOrderProductEntryIndex in currentOrderProductEntries) {
      if (currentOrderProductEntries && currentOrderProductEntries[currentOrderProductEntryIndex].product.code === deliveryItmMaterialNumber) {
        qtyShippedPrice = ACC.orderHistory.productDetailsPriceCalculation(currentOrderProductEntries[currentOrderProductEntryIndex], qtyDelivered);
      }
    }

    return qtyShippedPrice;
  },

  populatedToBeShippedDetailsEditQtyPrice: function(currentProduct, qtyDisplay, deliveryItm) {
    var toBeShippedQtyMain = currentProduct.parents('.ph-orderhistory_products').find(ACC.orderHistory.toBeShippedProductDetailClass + deliveryItm.materialNumber),
        qtyShippedPrice = '';

    toBeShippedQtyMain.find(ACC.orderHistory.orderHistoryQtyTextClass).next().find('span').html(qtyDisplay);

    qtyShippedPrice = ACC.orderHistory.shippedProductPriceCalculation(currentProduct, qtyDisplay, deliveryItm);

    toBeShippedQtyMain.find('.ph-orderhistory_price').find('span').html(qtyShippedPrice);
  },

  toBeShippedQtyValue: function(currentProduct, deliveryItm) {
    var toBeShippedQtyMain = currentProduct.parents('.ph-orderhistory_products').find(ACC.orderHistory.toBeShippedProductDetailClass + deliveryItm.materialNumber),
        toBeShippedQty = toBeShippedQtyMain.find(ACC.orderHistory.orderHistoryQtyTextClass).next().find('span').html();

    return toBeShippedQty;
  },

  hideShowToBeShippedProductDetails: function(currentProduct, deliveryItm) {
    var qtyPurchased = currentProduct.next().find(ACC.orderHistory.orderHistoryQtyTextClass).attr('data-qtypurchased'),
        qtyDeliveredFinal = currentProduct.next().find(ACC.orderHistory.orderHistoryQtyTextClass).next().find('span').html(),
        currentProductParent = currentProduct.parents('.ph-orderhistory_products'),
        shipmentDateParentMain = currentProduct.next().find('.ph-orderhistory_prodinfo'),
        backOrderedTextMain = shipmentDateParentMain.find('.ph-orderHistory__backOrdered'),
        shipmentDateStructure = '',
        shipmentDateVal = deliveryItm.shipmentDate,
        shippedOnLabel = $('.ph-orderHistory__shippedOnLabel').html(),
        deliveryItmMaterialNumber = String(deliveryItm.materialNumber),
        lineItemMain = currentProductParent.find(ACC.orderHistory.toBeShippedProductDetailClass + deliveryItmMaterialNumber);

    if (qtyPurchased === qtyDeliveredFinal) {
      lineItemMain.addClass('ph-d-none');
      lineItemMain.siblings(ACC.orderHistory.orderHistoryToBeShippedHeadingClass).addClass('ph-d-none');

      if (backOrderedTextMain.length > 0) {
        backOrderedTextMain.addClass('ph-d-none');
      }

      if (shipmentDateVal) {
        shipmentDateStructure = '<div class="ph-orderHistory__shipmentDate ph-col-12 ph-float-left ph-mt-1 ph-p-0">' + shippedOnLabel + '&nbsp;' + shipmentDateVal + '</div>';
        shipmentDateParentMain.append(shipmentDateStructure);
        shipmentDateParentMain.find('.ph-lazyloadestdate').addClass('ph-d-none');
      }
    } else {
      lineItemMain.siblings(ACC.orderHistory.orderHistoryToBeShippedHeadingClass).removeClass('ph-d-none');
    }
  },

  getDisplayofQty: function(currentProduct, deliveryItm) {
    var qtyDisplay = '',
        qtyPurchasedMainLine = currentProduct.next().find(ACC.orderHistory.orderHistoryQtyTextClass),
        qtyPurchased = qtyPurchasedMainLine.attr('data-qtypurchased'),
        qtyDelivered = deliveryItm.quantityDelivered;

    if (String(qtyDelivered) !== 'null' && qtyDelivered < parseInt(qtyPurchased, 10)) {
      var qtyToBeDelivered = qtyPurchased - qtyDelivered,
          qtyShippedPrice = '',
          toBeShippedQty = '',
          qtyDeliveredFinal = '';

      toBeShippedQty = parseInt(ACC.orderHistory.toBeShippedQtyValue(currentProduct, deliveryItm), 10);

      if (toBeShippedQty) {
        qtyToBeDelivered = toBeShippedQty - qtyDelivered;
        qtyDeliveredFinal = qtyPurchased - qtyToBeDelivered;
      } else {
        qtyDeliveredFinal = qtyDelivered;
      }

      currentProduct.next().find(ACC.orderHistory.orderHistoryQtyTextClass).next().find('span').html(qtyDeliveredFinal);

      qtyShippedPrice = ACC.orderHistory.shippedProductPriceCalculation(currentProduct, qtyDeliveredFinal, deliveryItm);

      currentProduct.next().find('.ph-orderhistory_price').find('span').html(qtyShippedPrice);

      qtyDisplay = qtyToBeDelivered;
    }

    return qtyDisplay;
  },

  generatePackingListSubFunction: function(currentProductParameter, deliveryItmParameter, deliveryItemHtmlParameter, productEntryCounterParameter) {
    var currentProduct = currentProductParameter,
        deliveryItm = deliveryItmParameter,
        deliveryItemHtml = deliveryItemHtmlParameter,
        productEntryCounter = productEntryCounterParameter,
        deliverypackinglistlabel = $('.deliverypackinglistlabel').text(),
        packingDocUrl = '/my-account/orderDoc?id=' + deliveryItm.deliveryNumber + '&type=PackagingSlip',
        qtyDisplay = '',
        qtyPurchased = currentProduct.next().find(ACC.orderHistory.orderHistoryQtyTextClass).attr('data-qtypurchased'),
        qtyDelivered = '',
        packingListDataObj = {};

    if (String($('.ph-ishhs').attr('data-integration')) === 'true') {
      qtyDisplay = ACC.orderHistory.getDisplayofQty(currentProduct, deliveryItm);

      if (String(deliveryItm.quantityDelivered) !== 'null' && deliveryItm.quantityDelivered < parseInt(qtyPurchased, 10)) {
        qtyDelivered = '<span class="ph-orderHistorylineItem__qty"> (Qty: ' + deliveryItm.quantityDelivered + ') </span>';
      }

      deliveryItemHtml = deliveryItemHtml + '<span class="ph-packagelist-foritem" packagenum="' + deliveryItm.deliveryNumber + '">';
      deliveryItemHtml = deliveryItemHtml + '<p><span class="ph-orderhistory_fontstyle">' + deliverypackinglistlabel + ':</span>';
      deliveryItemHtml = deliveryItemHtml + '<a href="#" onClick="openPopUp(\'' + packingDocUrl + '\')" class="packing-link">' + deliveryItm.deliveryNumber + '</a>' + qtyDelivered + '</p>';
      deliveryItemHtml = deliveryItemHtml + '</span>';
    }

    if (qtyDisplay) {
      productEntryCounter = productEntryCounter + 1;
      ACC.orderHistory.populateToBeShippedProductDetails(currentProduct, qtyDisplay, deliveryItm, productEntryCounter);
    }

    ACC.orderHistory.hideShowToBeShippedProductDetails(currentProduct, deliveryItm);

    packingListDataObj = {
      deliveryItemHtmlProperty: deliveryItemHtml,
      productEntryCounterProperty: productEntryCounter
    };

    return packingListDataObj;
  },

  generatePackingListHtml: function($currentProduct, invoiceDetail, deliveryItemList, productEntryCounterMain) {
    var currentProductCode = $currentProduct.attr('data-productcode'),
        productEntryCounter = productEntryCounterMain;

    /* eslint-disable  no-undefined */
    if (typeof invoiceDetail.deliveryNumber !== undefined && String(invoiceDetail.deliveryNumber) !== 'null') {
      /* eslint-enable  no-undefined */
      var deliveryItemHtml = '';

      for (var d = 0; d < deliveryItemList.length; d = d + 1) {
        var deliveryItm = deliveryItemList[d],
            materialNumberProductCode = String(deliveryItm.materialNumber).indexOf(String(currentProductCode));

        if (deliveryItm.confirmationNumber === invoiceDetail.confirmationNumber && deliveryItm.deliveryNumber === invoiceDetail.deliveryNumber && materialNumberProductCode >= 0) {
          var packingListDataObj = ACC.orderHistory.generatePackingListSubFunction($currentProduct, deliveryItm, deliveryItemHtml, productEntryCounter);

          deliveryItemHtml = packingListDataObj.deliveryItemHtmlProperty;
          productEntryCounter = packingListDataObj.productEntryCounterProperty;
        }
      }

      $currentProduct.append(deliveryItemHtml);
    }

    return productEntryCounter;
  },

  populateToBeShippedProductSubDetails: function(productEntryCounter, currentProductShippedLabelClass, toBeShippedLabel) {
    var productDetailsStructure = '';

    if (productEntryCounter === 1) {
      if (currentProductShippedLabelClass.length === 0) {
        productDetailsStructure = '<div class="ph-orders-tobeshippedlabel ph-orderhistory_fontstyle ph-orderHistory__toBeShipped--heading ph-col-12 ph-px-0 ph-py-1 ';
        productDetailsStructure = productDetailsStructure + 'ph-float-left ph-orderdelstatus-label">' + toBeShippedLabel + ':</div>';
      }
    }

    return productDetailsStructure;
  },

  populateToBeShippedProductDetails: function(currentProduct, qtyDisplay, deliveryItm, productEntryCounter) {
    var savedOrderDetailsMapData = $('.ph-orderHistory__savedProductEntryData').data('key'),
        productsMainClass = '.ph-orderhistory_products',
        currentProductMainClass = currentProduct.parents(productsMainClass),
        toBeShippedLabelClass = '.ph-orders-tobeshippedlabel',
        currentProductShippedLabelClass = currentProductMainClass.find(toBeShippedLabelClass),
        orderCode = currentProductMainClass.attr('data-orderidnumber'),
        currentOrderDetails = savedOrderDetailsMapData[orderCode],
        currentOrderProductEntries = currentOrderDetails.entries,
        productEntryData = '',
        toBeShippedLabel = $('.ph-orderhistory__tobeshippedlabel').html(),
        productDetailsStructure = '',
        deliveryItmMaterialNumber = String(deliveryItm.materialNumber),
        $materialNumberClass = currentProduct.parents('.ph-orderhistory_products').find(ACC.orderHistory.toBeShippedProductDetailClass + deliveryItmMaterialNumber);

    for (var currentOrderProductEntryIndex in currentOrderProductEntries) {
      if (currentOrderProductEntries && currentOrderProductEntries[currentOrderProductEntryIndex].product.code === deliveryItmMaterialNumber) {
        if ($materialNumberClass.length === 0) {
          productDetailsStructure = ACC.orderHistory.populateToBeShippedProductSubDetails(productEntryCounter, currentProductShippedLabelClass, toBeShippedLabel);

          productEntryData = ACC.orderHistory.productDetailsSubData(currentOrderProductEntries[currentOrderProductEntryIndex], qtyDisplay);

          productDetailsStructure = productDetailsStructure + '<div class="ph-orderhistory_tobeshippedproduct ph-col-12 ph-p-0 ph-mb-1 ph-float-left ph-toBeShippedProductDetail--' +
                                    deliveryItmMaterialNumber + ' ph-toBeShippedProductDetail--generalClass">' + productEntryData + '</div>';
        } else {
          ACC.orderHistory.populatedToBeShippedDetailsEditQtyPrice(currentProduct, qtyDisplay, deliveryItm);
        }
      }
    }

    if (currentProductMainClass.length > 0) {
      currentProductMainClass.append(productDetailsStructure);
    }
  },

  productDetailsPriceCalculation: function(data, qtyDisplay) {
    var qtyBasedPriceWithSymbol = '';

    if (data.basePrice && data.basePrice.formattedValue) {
      var qtyBasedPrice = '',
          basePrice = data.basePrice.formattedValue,
          extractNumbersFromPrice = basePrice.replace(/[^\d.,]/gi, ''),
          extractCurrencyFromPrice = basePrice.replace(/[\d.,]/gi, ''),
          priceMultipliedWithQuantity = extractNumbersFromPrice * qtyDisplay;

      qtyBasedPrice = priceMultipliedWithQuantity.toFixed(2);

      qtyBasedPriceWithSymbol = ACC.orderHistory.generateCurrencySymbol(data, extractCurrencyFromPrice, qtyBasedPrice);
    }

    return qtyBasedPriceWithSymbol;
  },

  shippedOnDetails: function(shipmentDateValue) {
    var shippedOnLabel = $('.ph-orderHistory__shippedOnLabel').html(),
        shipmentDatestructureData = '';

    if (shipmentDateValue) {
      shipmentDatestructureData = '<div class="ph-orderHistory__shipmentDate ph-col-12 ph-float-left ph-p-0">' +
                      '<span class="ph-orderHistory-shippedOnLabelClass">' + shippedOnLabel + '&nbsp;</span><span class="ph-orderHistory-shippedOnValue">' +
                      shipmentDateValue + '</span></div>';
    }

    return shipmentDatestructureData;
  },

  estDeliveryDetails: function(estDeliveryDateValue) {
    var estDeliveryLabel = $('.ph-orderHistory__estDeliveryLabel').html(),
        estDeliveryStructureData = '';

    if (estDeliveryDateValue) {
      estDeliveryStructureData = '<div class="ph-loadestdate ph-col-12 ph-float-left ph-p-0 ph-orderhistory_productname">' +
                      '<span class="ph-orderHistory-estDeliveryLabelClass">' + estDeliveryLabel + '&nbsp;</span><span class="ph-orderHistory-estDeliveryValue">' +
                      estDeliveryDateValue + '</span></div>';
    }

    return estDeliveryStructureData;
  },

  productDetailsSubData: function(data, qtyToBeShipped) {
    var prodlistStruc = '',
        dataProductApproval = '',
        qtyBasedPrice = '';

    prodlistStruc = prodlistStruc + '<ul class="ph-m-0">\n ' +
      '<li class="ph-orderhistory_productlist ph-float-left ph-p-0 ph-m-0 ph-col-12 ph-mt-1">\n ';

    prodlistStruc = prodlistStruc + ACC.newOrderHistory.setProductImage(data);

    if (data.product && data.product.approval) {
      dataProductApproval = data.product.approval;
    }

    qtyBasedPrice = ACC.orderHistory.productDetailsPriceCalculation(data, qtyToBeShipped);

    prodlistStruc = prodlistStruc + '<div class="prod_info ph-float-left ph-pr-0 ph-orderhistory_prodinfo">\n' +
        '<div class="ph-col-md-7 ph-float-left ph-col-sm-12 ph-p-0">\n' +
        '<a class="ph-orderhistory_prodname ph-orderhistory_excluded ph-col-12 ph-float-left ph-p-0" data-productApproval= "' + dataProductApproval + '" ';

    prodlistStruc = prodlistStruc + ACC.orderHistory.productDetailsCondition(data);

    prodlistStruc = prodlistStruc + '</a><div class="ph-orders__invoice__details ph-float-left ph-col-12 ph-p-0" id="productDetails_' + data.entryNumber + '"></div></div>\n' +
      '<div class="ph-float-left ph-orderhistory_prodprice ph-orderhistory_fontstyle ph-orderhistory_productname ph-col-md-5 ph-col-sm-12 ph-p-0">\n' +
      '<div class="ph-orderhistory_qty ph-col-6 ph-float-left ph-p-0">\n' +
      '<span class="ph-orderhistory_qtytext">' + $('.ph-orderhistory__qty').text() + ' : </span>\n' +
      '<span><span>' + qtyToBeShipped + '</span>';

    if (data.product && $('.ph-displayuom').html() === 'true') {
      prodlistStruc = prodlistStruc + '<span>' + data.product.unitOfMeasure + '</span>\n';
    }

    prodlistStruc = prodlistStruc + '</span>\n' +
      '</div>\n' +
      '<div class="ph-orderhistory_price ph-col-6 ph-float-left ph-p-0">\n' +
      '<span>' + qtyBasedPrice + '</span>\n' +
      '</div>\n' +
      '</div>\n' +
      '</div>\n' +
      '<div class="ph-identifystatusestd-' + String(data.deliveryStatus) + ' ph-col-12 ph-float-left ph-m-0 ph-p-0 ph-lazyloadestdate" id="lazyloadestdate' +
       data.orderCode + '_' + data.entryNumber + '"></div>';

    if ((data.deliveryStatus === 'SHIPPED' || data.deliveryStatus === 'INVOICED') && data.shipmentDate) {
      prodlistStruc = prodlistStruc + ACC.orderHistory.shippedOnDetails(data.shipmentDate);
    } else if ((data.entryNumber === data.deliveryItemsQuantity) && data.orderCode === data.confirmationNumber && data.estDelDate) {
      prodlistStruc = prodlistStruc + ACC.orderHistory.estDeliveryDetails(data.estDelDate);
    }

    prodlistStruc = prodlistStruc + '</li>\n' +
      '</ul>';

    return prodlistStruc;
  },

  generateInvoiceListHtml: function(invoiceDetails, invoiceButtonFlag) {
    var invoiceListHtmlReturned = '',
        checkingUniq = [0];

    for (var i = 0; i < invoiceDetails.length; i = i + 1) {
      var invoiceDetail = invoiceDetails[i];

      if (String(invoiceDetail) !== 'null' && String(invoiceDetail.invoiceNumber) !== 'null' && checkingUniq.indexOf(invoiceDetail.invoiceNumber) < 0) {
        var invoiceDocUrl = '/my-account/orderDoc?id=' + invoiceDetail.invoiceNumber + '&type=Invoice',
            invoiceNumber = invoiceDetail.invoiceNumber;

        if (String(invoiceButtonFlag) === 'true') {
          invoiceDocUrl = '/my-account/getInvoice.json/?invoice=' + invoiceDetail.invoiceNumber;
        }

        checkingUniq.push(invoiceDetail.invoiceNumber);
        invoiceListHtmlReturned = invoiceListHtmlReturned + '<a href="#" onClick="openPopUp(\'' + invoiceDocUrl + '\')" class="invoice-link ph-orderhistory__invoiceno ph-col-12 ph-float-left">' + invoiceNumber + '</a>';
      }
    }

    return invoiceListHtmlReturned;
  },
  getFinalDeliveryStatus: function(productEntryData, deliveryStatusValue) {
    var finalDelStatus = deliveryStatusValue,
        trackingAvailable = false;

    if (productEntryData.orderEntryTrackingURLDetails.length > 0 &&
       String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== 'undefined' && String(productEntryData.orderEntryTrackingURLDetails[0].trackingURL) !== '') {
      trackingAvailable = true;
    }

    if ($('.ph-ishhs').html() === 'true' && trackingAvailable === true) {
      finalDelStatus = 'shipped';
    } else if ($('.ph-ishhs').html() === 'true' && trackingAvailable === false) {
      finalDelStatus = 'tobeshipped';
    }

    return finalDelStatus;
  },
  tobeShippedConditionSplit: function(productEntryData) {
    var tobeshippedStatusListArray = [
          'NOTSHIPPED',
          'PARTSHIPPED'
        ],
        tobeshippedConditions = false;

    if (!productEntryData.deliveryStatus || ($.inArray(productEntryData.deliveryStatus, tobeshippedStatusListArray) !== -1)) {
      tobeshippedConditions = true;
    }

    return tobeshippedConditions;
  },
  getDeliveryStatusValue: function(productEntryData) {
    var deliveryStatusValue = 'others',
        returndStatusListArray = [
          'PARTRETURNED',
          'RETURNED'
        ],
        returnprogressStatusListArray = [
          'RETURN_IN_PROGRESS',
          'FULL_RETURN_SUBMITTED',
          'PARTIAL_RETURN_SUBMITTED'
        ],
        shippedStatusListArray = [
          'SHIPPED',
          'INVOICED',
          'PARTSHIPPED',
          'PARTINVOICED'
        ];

    if (ACC.orderHistory.tobeShippedConditionSplit(productEntryData) === true) {
      deliveryStatusValue = 'tobeshipped';
    } else if (productEntryData.deliveryStatus && ($.inArray(productEntryData.deliveryStatus, returndStatusListArray) !== -1)) {
      deliveryStatusValue = 'returned';
    } else if (productEntryData.deliveryStatus && ($.inArray(productEntryData.deliveryStatus, returnprogressStatusListArray) !== -1)) {
      deliveryStatusValue = 'returnprogress';
    } else if (productEntryData.deliveryStatus && ($.inArray(productEntryData.deliveryStatus, shippedStatusListArray) !== -1)) {
      deliveryStatusValue = 'shipped';
    }

    return ACC.orderHistory.getFinalDeliveryStatus(productEntryData, deliveryStatusValue);
  },
  renderGroupedOrderProducts: function(groupOrderProducts) {
    var groupedOrderProductsData = '',
        returnedlabel = $('.ph-orderhistory__returnedlabel').html(),
        returnprogresslabel = $('.ph-orderhistory__returnprogresslabel').html(),
        tobeshippedlabel = $('.ph-orderhistory__tobeshippedlabel').html();

    if (groupOrderProducts.shipped) {
      groupedOrderProductsData = groupedOrderProductsData + groupOrderProducts.shipped;
    }

    if (groupOrderProducts.others) {
      groupedOrderProductsData = groupedOrderProductsData + groupOrderProducts.others;
    }

    if (groupOrderProducts.returned) {
      groupedOrderProductsData = groupedOrderProductsData +
       '<div class="ph-orders-returnedlabel ph-col-12 ph-p-0 ph-mt-0 ph-float-left ph-orderdelstatus-label">' + returnedlabel + ':</div>';
      groupedOrderProductsData = groupedOrderProductsData + groupOrderProducts.returned;
    }

    if (groupOrderProducts.returnprogress) {
      groupedOrderProductsData = groupedOrderProductsData +
       '<div class="ph-orders-returnprogresslabel ph-col-12 ph-p-0 ph-mt-0 ph-float-left ph-orderdelstatus-label">' + returnprogresslabel + ':</div>';
      groupedOrderProductsData = groupedOrderProductsData + groupOrderProducts.returnprogress;
    }

    if (groupOrderProducts.tobeshipped) {
      groupedOrderProductsData = groupedOrderProductsData +
       '<div class="ph-orders-tobeshippedlabel ph-col-12 ph-p-0 ph-mt-0 ph-float-left ph-orderdelstatus-label">' + tobeshippedlabel + ':</div>';
      groupedOrderProductsData = groupedOrderProductsData + groupOrderProducts.tobeshipped;
    }

    return groupedOrderProductsData;
  },
  productDetailsCondition: function(data) {
    var backOrdered = $('.ph-text-backordered').text(),
        discontinuedProduct = $('.ph-text-hasbeendiscontinued').text(),
        notAvailableProduct = $('.ph-text-nolongeravailable').text(),
        prodlistCondStruc = '';

    if (data.product) {
      if (data.product.isLumifyWarranty !== '' && data.product.isLumifyWarranty !== null) {
        if (data.product.approval === 'approved' || data.product.approval === 'regulatoryonhold') {
          prodlistCondStruc = prodlistCondStruc + 'href=' + data.product.url + '>';
        }
      }

      prodlistCondStruc = prodlistCondStruc + '<p class="ph-orderhistory_productname ph-orderhistory_fontstyle ph-m-0 strong">' + data.product.name + '</p>\n' +
        '<p class="ph-orderhistory_productCtn ph-orderhistory_productname ph-m-0">' + data.product.ctn + '</p>';


      if ((data.product.code !== '') && data.product.code !== data.product.ctn) {
        prodlistCondStruc = prodlistCondStruc + '<span>' + data.product.code + ' </span>';
      }

      if (data.isBackordered === true) {
        prodlistCondStruc = prodlistCondStruc + '<p class="ph-orderHistory__backOrdered" style="color:red">' + backOrdered + '</p>';
      }

      if (data.product.approval === 'discontinued') {
        prodlistCondStruc = prodlistCondStruc + '<p class="ph-m-0" style="color: red">' + discontinuedProduct + '</p>';
      }

      if (data.product.approval !== 'approved' && data.product.approval !== 'regulatoryonhold' && data.product.approval !== 'discontinued') {
        prodlistCondStruc = prodlistCondStruc + '<p class="ph-m-0" style="color: red">' + notAvailableProduct + '</p>';
      }
    }

    return prodlistCondStruc;
  },
  isThirtyDayMaskOrder: function(thirtyDayMaskOrderData) {
    var hideBtns = '',
        isSrcNonorderGrp = $('.ph-srcNonordergrp').val();

    if ((thirtyDayMaskOrderData && thirtyDayMaskOrderData.thirtyDayMaskOrder === true) || isSrcNonorderGrp === 'false') {
      hideBtns = 'hidden';
    }

    return hideBtns;
  },
  renderReturnOrderBtn: function(orderdetailsData) {
    var returnOrder = '\n';

    if (orderdetailsData.isEligibleForReturn) {
      returnOrder = '<button class="ph-orderhistory_return ph-col-4 ph-float-left" data-orderid="' + orderdetailsData.code +
      '" data-submitbtn="Submit" data-cancelbtn="Cancel">' + $('.ph-text-returnproducts').text() + '</button>\n';
    }

    return returnOrder;
  }
};
window.addEventListener('DOMContentLoaded', function() {
  if ($('.ph-orderhistory').length > 0) {
    ACC.orderHistory.bindAll();
  }

  function manageApprovalOrders() {
    if (($('.' + ACC.orderHistory.phOrders).length === 0) && ($('.ph-myApprovalOrders').length === 0)) {
      $('.' + ACC.orderHistory.phApprovalOrders).html('');
    }

    if ($('.' + ACC.orderHistory.phOrders).is(':checked') && $('.ph-myApprovalOrders').length === 0) {
      $('.' + ACC.orderHistory.phApprovalOrders).html('');
    }
  }

  manageApprovalOrders();
});

/* eslint-enable complexity */
/* eslint-enable no-implicit-globals */
